import React from "react";
import { Box, CardMedia, Typography } from "@mui/material";
import { Image } from "@mui/icons-material";

interface VenueCardImageProps {
  imageUrl: string | null;
  venueName: string;
  height?: number;
}

export const VenueCardImage: React.FC<VenueCardImageProps> = ({
  imageUrl,
  venueName,
  height = 180,
}) => {
  if (imageUrl) {
    return (
      <CardMedia
        className="card-image"
        component="img"
        height={height}
        image={imageUrl}
        loading="lazy"
        alt={venueName}
        sx={{
          objectFit: "cover",
          transition: "transform 0.4s ease",
        }}
      />
    );
  }

  return (
    <Box
      className="card-image"
      height={height}
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        background: "linear-gradient(135deg, #E5BFA5 0%, #614438 100%)",
        color: "white",
        transition: "transform 0.4s ease",
      }}
    >
      <Box textAlign="center">
        <Image sx={{ fontSize: 50, opacity: 0.7 }} />
        <Typography variant="body2" sx={{ mt: 1, opacity: 0.8 }}>
          No Image
        </Typography>
      </Box>
    </Box>
  );
};

export default VenueCardImage;
